export var DateTimeRangeMatchType;
(function (DateTimeRangeMatchType) {
    DateTimeRangeMatchType[DateTimeRangeMatchType["OlderThanTimespan"] = 0] = "OlderThanTimespan";
    DateTimeRangeMatchType[DateTimeRangeMatchType["YoungerThanTimespan"] = 1] = "YoungerThanTimespan";
    DateTimeRangeMatchType[DateTimeRangeMatchType["WithinTimespan"] = 2] = "WithinTimespan";
    DateTimeRangeMatchType[DateTimeRangeMatchType["BetweenDay"] = 3] = "BetweenDay";
    DateTimeRangeMatchType[DateTimeRangeMatchType["BeforeDays"] = 4] = "BeforeDays";
    DateTimeRangeMatchType[DateTimeRangeMatchType["AfterDays"] = 5] = "AfterDays";
    DateTimeRangeMatchType[DateTimeRangeMatchType["DateRange"] = 6] = "DateRange";
})(DateTimeRangeMatchType || (DateTimeRangeMatchType = {}));
;
